import { createLegacyModule } from "./createLegacyModule";

const keys = [
  "I have read and agreed",
  "at TIME point ONE part",
  "Choose up to ONE copy",
  "kind",
  "listA_title",
  "Minimum consumption",
  "minute",
  "refreshUp",
  "Release refresh",
  "stop",
  "This group can be selected at most",
  "This item is optional"
];

export default createLegacyModule(keys);
